module.exports = __webpack_public_path__ + "img/df-logo.37b2850e.png";